const admin = {
  state: {
    licence: null,
    dataPrivacy: null,
    termsAndConditions: null,
    admin: null,
    adminBasic: null
  },
  mutations: {
    changeAdmin(state, payload) {
      state.admin = payload;
    },
    changeAdminBasic(state, payload) {
      state.adminBasic = payload;
    },
    changeLicence(state, payload) {
      state.licence = payload;
    },
    changeDataPrivacy(state, payload) {
      state.dataPrivacy = payload;
    },
    changeTermsAndConditions(state, payload) {
      state.termsAndConditions = payload;
    }
  },
  actions: {
    changeAdmin({ commit }, payload) {
      commit("changeAdmin", payload);
    },
    changeAdminBasic({ commit }, payload) {
      commit("changeAdminBasic", payload);
    },
    changeLicence({ commit }, payload) {
      commit("changeLicence", payload);
    },
    changeDataPrivacy({ commit }, payload) {
      commit("changeDataPrivacy", payload);
    },
    changeTermsAndConditions({ commit }, payload) {
      commit("changeTermsAndConditions", payload);
    }
  },
  getters: {
    getAdmin: state => {
      return state.admin;
    },
    getAdminBasic: state => {
      return state.adminBasic;
    },
    getLicence: state => {
      return state.licence;
    },
    getDataPrivacy: state => {
      return state.dataPrivacy;
    },
    getTermsAndConditions: state => {
      return state.termsAndConditions;
    }
  }
};
export default admin;
